import {
    POST_PACKAGE,
    PATCH_PACKAGE,
    GET_WIZARDS,
    GET_PACKAGES
  } from "resources/ApiUrls"
  import MyAxiosInstance from "utils/MyAxiosInstance"
  
  const getAllWizards = () => MyAxiosInstance.get(GET_WIZARDS)
  
  const getPackages = () => MyAxiosInstance.get(GET_PACKAGES);
  
  const create = (centerId, packageObject) => MyAxiosInstance.post(POST_PACKAGE(centerId), packageObject)
  
  const update = (packageId, packageObject) => MyAxiosInstance.patch(PATCH_PACKAGE(packageId), packageObject)
  
  const packagesAPICalls = { getAllWizards, getPackages, create, update }
  
  export default packagesAPICalls
  